module.exports = __webpack_public_path__ + "img/slide2.f8f07058.png";